// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorContributionAddTemplate_heading__DsLb1","buttonLink":"LandscapeIndicatorContributionAddTemplate_buttonLink__0FQR3"};